export default __webpack_public_path__ + "0a542883f6bd71acd8a4532d4949871c.svg";